import React from 'react'
import { Loader } from '@web/walter-ui-kit'

import styles from './style.module.css'

function Balance() {
    return (
        <div className={styles.wrap}>
            <div className={styles.balanceTitle}>
                <Loader width={88} height={17} />
            </div>
            <div className={styles.balance}>
                <Loader width={200} height={32} />
            </div>

            <div className={styles.change}>
                <Loader width={56} height={17} />
                <Loader width={56} height={17} />
                <Loader width={56} height={17} />
            </div>
        </div>
    )
}

function Tabs() {
    return (
        <>
            <div className={styles.tabs}>
                <Loader width={100} height={17} />
                <Loader width={100} height={17} />
            </div>

            <div className={styles.separator} />

            <div className={styles.subtabs}>
                <Loader width={90} height={28} />
                <Loader width={90} height={28} />
            </div>
        </>
    )
}

function Preloader() {
    return (
        <div>
            <Balance />
            <Tabs />
        </div>
    )
}

export default Preloader
